window.modalTemplate = function (id, method = 'POST') {
    return `<div class="modal fade" id="${id}" tabindex="-1" role="dialog" aria-labelledby="${id}Label"
     aria-hidden="true">
    <div class="modal-dialog" role="document">
        <form action="" method="${method}" data-submit="axios">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="${id}Label"></h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="inputs">
                    </div>
                    <p class="text-danger message"></p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm" style="position: absolute; left: 10px" onclick="cleanModalForm('${id}')">Limpiar campos</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                    <button class="btn btn-primary">Guardar</button>
                </div>
            </div>
        </form>
    </div>
</div>`
}
